import { useGetExerciseArticleRouter } from './fn/useGetExerciseArticleRouter'

export const ExerciseArticleControllerNew = {
	router: useGetExerciseArticleRouter,
}
